<template>
  <div class="container">
    <!--UPLOAD-->
    <form enctype="multipart/form-data" novalidate>
      <div v-if="isProductFlowEnabled">
        <h5 v-if="imagePath" data-qa="changeImgLabel">{{ $t('changePimage') }}</h5>
        <h3 v-else data-qa="uploadImgLabel">{{ $t('addPimage') }}</h3>
      </div>
      <div v-else>
        <h5 v-if="imagePath">{{ $t('changeEimage') }}</h5>
        <h3 v-else>{{ $t('addEimage') }}</h3>
      </div>
      <div class="tipWrapper">
        <div class="help-tip">
          <p class="help-tip-bg-color">
            {{ $t('proposedDim') }}: <strong>500x500 px</strong><br />
            {{ $t('proposedFormate') }}: <strong>.png</strong><br />
            {{ $t('proposedSize') }}: <strong>0.3Mb</strong>
          </p>
        </div>
      </div>
      <div class="dropbox">
        <input
          type="file"
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="filesChange($event.target.name, $event.target.files)"
          accept="image/*"
          class="input-file"
		  data-qa="uploadImgButton"
        />
        <p v-if="!imagePath">
          {{ $t('uploadInstuctions1') }}<br />
          {{ $t('uploadInstuctions2') }}
        </p>
        <p v-if="isSaving">
          {{ $t('uploading') }}
        </p>
        <img
          v-if="imagePath || isSuccess"
          :src="`${imagePath}`"
          class="img-responsive img-thumbnail"
          alt="No image found"
        />
      </div>
    </form>
    <!--SUCCESS-->
    <!-- <div v-if="isSuccess">
            <h2>Image uploaded successfully.</h2>
            <p>
            <a href="javascript:void(0)" @click="reset()">Upload again</a>
            </p>
            <ul class="list-unstyled">
            <li :key = "item" v-for="item in uploadedFiles">
                <img 
                :src="item.url" 
                class="img-responsive img-thumbnail" 
                :alt="item.originalName">
            </li>
            </ul>
        </div> -->
    <!--FAILED-->
    <div v-if="isFailed">
      <h2>Uploaded failed.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Try again</a>
      </p>
      <!-- <pre>{{ uploadError }}</pre> -->
    </div>
  </div>
</template>

<script>
import { upload } from '@/services/prodImgUpload.service.js'
import constants from '@/utils/Constants.js'

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3

export default {
  name: 'app',
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'file',
      baseUrl: process.env.VUE_APP_API_URL,
      imagePath: this.imageUrl,
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      var paramsJson = this.isProductFlowEnabled
        ? {
            product_id: this.productId,
            type: constants.PRODUCT_IMAGE,
          }
        : {
            experience_id: this.experienceId,
            type: constants.EXPERIENCE_IMAGE,
          }
      upload(formData, paramsJson)
        .then((x) => {
          this.uploadedFiles = [].concat(x)
          this.imagePath = x.cloudUrl
          this.currentStatus = STATUS_SUCCESS
        })
        .catch((err) => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name)
      })

      // save it
      this.save(formData)
    },
  },
  mounted() {
    this.reset()
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    experienceId: {
      type: Number,
      required: true,
    },
    isProductFlowEnabled: {
      type: Boolean,
      required: true,
    },
    imageUrl: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  padding: 0;
  width: 100%;
}
form h3 {
  text-align: center;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: rgba(44, 62, 80, 0.2);
  color: dimgray;
  padding: 10px 10px;
  position: relative;
  width: 300px;
  height: auto;
  cursor: pointer;
}

.container {
  display: inline-block;
  width: 60%;
  margin: 0;
  padding: 0;
  height: auto;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  left: 0;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: rgba(
    185,
    123,
    66,
    0.4
  ); /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/*** TOOL TIP CSS ***/
.tipWrapper {
  position: relative;
}

.help-tip {
  position: absolute;
  bottom: 10px;
  right: 5px;
  text-align: center;
  background-color: var(--grey-Dark) !important;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 26px;
  cursor: default;
  z-index: 1;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip-bg-color {
 background-color: var(--bg-light) !important;
}

.help-tip:hover {
  cursor: pointer;
  background-color: var(--primaryDark) !important;
}

.help-tip:before {
  content: '?';
  font-weight: 700;
  color: #fff;
}

.help-tip p {
  visibility: hidden;
  opacity: 0;
  margin-top: 3px;
  text-align: left;
  background-color: var(--grey-Dark);
  padding: 20px;
  width: 300px;
  margin-top: 3px;
  position: absolute;
  border-radius: 4px;
  right: -4px;
  color: #fff;
  font-size: 13px;
  line-height: 1.2rem;
  transform: scale(0.7);
  transform-origin: 100% 0%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}
.help-tip:active p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}

.help-tip p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: var(--grey-Dark);
  right: 10px;
  top: -12px;
}

.help-tip p:after {
  width: 100%;
  height: 40px;
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
}

.help-tip a {
  color: #fff;
  font-weight: 700;
}

.help-tip a:hover,
a:active .help-tip a:focus {
  color: #fff;
  text-decoration: underline;
}
// end of question tooltip//

@media screen and (min-width: 1351px) {
  .dropbox {
    width: 300px;
    margin: auto;
  }
}
@media screen and (max-width: 1350px) {
  .dropbox {
    width: 300px;
    margin: auto;
  }
}

@media screen and (max-width: 500px) {
	form h3 {
		font-size: 1.1rem;
	}
  .container {
    width: 100%;
  }
  .dropbox {
    width: 100%;
  }
  .help-tip p {
	width: max-content;
  }
}

@media screen and (max-width: 350px) {
  .help-tip p {
	font-size: 0.6rem;
  }
}
</style>
